
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { PATHS } from '../../common/constants';
import { clearServiceRequests } from '../../store/actions/serviceRequests';
import Col from '../../components/Col';
import Row from '../../components/Row';
import RecentActivity from '../../components/HomeOwnerDashboard/RecentActivity';
import { selectRecentActivity } from '../../store/selectors/RecentActivity';
import { fetchRecentActivity } from '../../store/actions/RecentActivity';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { selectPropertyWalkThroughFormIsVisible } from '../../store/selectors/propertyWalkThroughForm';
import Overlay from '../../components/Overlay';
import Video from '../../components/HomeOwnerDashboard/DisplayVideo';
import { fetchAssetsBySuiteId } from '../../store/actions/assets'
import { selectCurrentUserSuite } from '../../store/selectors/userSuites';
import HomeOwnerDashboardvsOnboardingDashboard from './HomeOwnerDashboardvsOnboardingDashboard';
import WithNavigation from 'src/layouts/WithNavigation/WithNavigation';

class Dashboard extends Component {

  state = {
    isPlayVideo: false,
    videoObj: {},
    newData: []
  }
  componentWillMount() {
    const { user, onFetchRecentActivity,onfetchAssetsBySuiteId ,currentUserSuite} = this.props;
    if(currentUserSuite && currentUserSuite.status === 'Occupied') {
      onFetchRecentActivity(currentUserSuite.id);
      onfetchAssetsBySuiteId(currentUserSuite.id, false);
    }
if (user.isDashboardAccess===false) {
    localStorage.setItem('propertyId',currentUserSuite.propertyId);
    localStorage.setItem('suiteId',currentUserSuite.id);
}
    
  }

  componentDidUpdate(prevProps, prevState){
    const {currentUserSuite: prevCurrentUserSuite} = prevProps
    const {currentUserSuite} = this.props
    if(prevCurrentUserSuite.id !== currentUserSuite.id){
      const { user, onFetchRecentActivity,onfetchAssetsBySuiteId ,currentUserSuite} = this.props;
      if(currentUserSuite && currentUserSuite.status === 'Occupied') {
      onFetchRecentActivity(currentUserSuite.id);
      onfetchAssetsBySuiteId(currentUserSuite.id, false);
      }

      if(user.isDashboardAccess===false) {
      localStorage.setItem('propertyId',currentUserSuite.propertyId);
      localStorage.setItem('suiteId',currentUserSuite.id);
      }
    }
  }
  onClick = () => {
    this.props.history.push(PATHS.SERVICE_REQUESTS_LIST)
    clearServiceRequests()
  }
  async onChange(data) {
    const { propertyVideos } = this.props;
    let newData = this.state.newData;
    let latestArray = propertyVideos.filter(item => item.id !== data.id)
    newData = [data, ...latestArray]
    this.setState({ videoObj: data, newData: newData }, () => this.isShow())
  }
  isShow = () => {
    this.setState({ isPlayVideo: true })
  }
  render() {
    const { recentActivity, propertyWalkThroughFormIsVisible, currentUserSuite, onboardingData } = this.props;
   // const showRecentActivity = (currentUserSuite && currentUserSuite.status === 'Occupied' || currentUserSuite && currentUserSuite.status !== 'Occupied' && onboardingData.orders.length === 0);
    const showRecentActivity = false;
    return (
      <div style={{ overflow: "hidden" }}>
        <Row>
          <Col md={ showRecentActivity ? 10 : 12}>
            <WithNavigation
              title="Dashboard"
              border
              top={
                <HomeOwnerDashboardvsOnboardingDashboard 
                  onClick={this.onClick}
                  history={this.props.history}
                  onChange={(data) => this.onChange(data)}
                />
              }
            />
          </Col>
          {propertyWalkThroughFormIsVisible === true ||
            this.state.isPlayVideo ? null : (
              showRecentActivity ?
            <Col md={2}>
              {recentActivity.length > 0 ? (
                <RecentActivity data={recentActivity} />
              ) : (
                ""
              )}
            </Col> : null
          )}
        </Row>
        <Overlay
          showOverlay={this.state.isPlayVideo}
          content={
            <Video
              videoObj={this.state.videoObj}
              propertyVideos={this.state.newData}
              onClose={() => this.setState({ isPlayVideo: false })}
            />
          }
        />
      </div>
    );
  };
}


const mapStateToProps = (state) => ({
  user: selectAuthenticatedUser(state),
  recentActivity: selectRecentActivity(state),
  propertyWalkThroughFormIsVisible: selectPropertyWalkThroughFormIsVisible(state),
  propertyVideos: state.PropertyVideos,
  currentUserSuite : selectCurrentUserSuite(state),
  onboardingData: state.onboardingData
})
const maptDispatchToProps = dispatch => bindActionCreators({
  clearServiceRequests,
  onFetchRecentActivity: fetchRecentActivity,
  onfetchAssetsBySuiteId: fetchAssetsBySuiteId,

}, dispatch)
export default connect(mapStateToProps, maptDispatchToProps)(Dashboard);
